import { render, staticRenderFns } from "./SalesRecapPrintDetails_Total.vue?vue&type=template&id=746744b5&"
import script from "./SalesRecapPrintDetails_Total.vue?vue&type=script&lang=js&"
export * from "./SalesRecapPrintDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports